module.exports = {
      id: "magazines-usage",
      viewBox: "0 0 25.36 20.288",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#magazines",
      toString: function () {
        return this.url;
      }
    }